import { ISettings } from "./ISettings";

export class ProdSettings implements ISettings {
    serverUrl = "https://supervision-api.pandoiq.com";
    notificationServerUrl = "https://notification.algoteam.net";
    vendorManagementUrl = "https://txph2o7gk8.execute-api.us-east-1.amazonaws.com/prod";
    explainabilityServiceUrl = "https://qd451wgiqd.execute-api.us-east-1.amazonaws.com/prod"
    attributesManagementServiceUrl = "https://api-attributes.algoteam.net";
}
